import onEventCreator from './events'
import appApiCreator from './api'
import { createPublicApi } from './publicApi'

const createModuleFactories = async services => ({
  getModuleName: () => 'core',
  createAppApi: () => appApiCreator(services),
  createEventHandlers: ({ appApi }) => onEventCreator({ ...services, appApi }),
})

const publicApi = createPublicApi()

export default { createModuleFactories, publicApi }
